'use client';

import * as React from 'react';

/**
 * Tracks the user's `prefers-reduced-motion` setting. Every spring/entrance
 * in the app checks this so motion is a preference, not an imposition.
 * SSR-safe: assumes motion is allowed until the client confirms otherwise.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = React.useState(false);

  React.useEffect(() => {
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mql.matches);
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
